import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import { store } from './store/index'
import './registerServiceWorker'

import Vue2TouchEvents from 'vue2-touch-events'
// import 'vuetify/src/stylus/app.styl';

import Vuetify from 'vuetify';
import { theme } from './plugins/vuetify'


Vue.use(require('vue-moment'));

Vue.use(Vue2TouchEvents)
Vue.use(Vuetify,theme);

// Event bus 
export const bus = new Vue();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
